module.exports = __webpack_public_path__ + "static/media/AMC-BG-divider.fca5285c.svg";